<script setup lang="ts">
import cover from "@brand-cover"

interface GuestBackgroundImageProps {
  isLoading?: boolean
  coverImage?: string
}

withDefaults(defineProps<GuestBackgroundImageProps>(), { isLoading: false, coverImage: "" })
</script>

<template>
  <img
    v-if="!isLoading && coverImage"
    :src="coverImage"
    class="hidden md:block fixed mt-0 h-full blur-lg brightness-75 scale-[1.1] z-[-1] inset-0 bg-cover bg-center w-full object-cover"
  >
  <img
    v-else
    :src="cover"
    class="hidden md:block fixed mt-0 h-full blur-lg brightness-75 scale-[1.1] z-[-1] inset-0 bg-cover bg-center w-full object-cover"
  >
</template>
